export default __webpack_public_path__ + "static/21-4afdc6ed4f588f6f1286ea7962507afb.webp";